<template lang="pug">
div
  draggable(
    v-model="lessons"
    :group="draggable[unitId]"
    handle=".handle"
    @change="$emit('change-lesson-order', $event, lessons)"
  )
    v-list-item.mb-0.px-0.handle.lesson-item(
      v-for="(lesson, idx) in lessons"
      :key="lesson.id"
      @click="$emit('lesson-tasks', lesson)"
    )
      v-list-item-action.mr-5(v-if="editable")
        v-icon mdi-drag
      v-list-item-content
        .text-body-1 {{ lesson.name }}
        v-list-item-subtitle
          v-chip(
            color="secondary"
            x-small
          ).px-2 {{lesson.tasks.length}}
          span.caption.ml-1 Задания
        //- .caption.grey--text Урок {{ idx + 1 }}
      v-list-item-action.mr-4(v-if="lesson.meeting")
        v-menu(
          :close-on-content-click="false"
          nudge-width="350"
          offset-y
          transition="slide-y-transition"
        )
          template(v-slot:activator="{ on }")
            v-btn(
              v-on="on"
              title="Ссылка на трансляцию"
              icon
            )
              v-icon(small color="primary") mdi-video
          v-card
            v-card-text.pa-3
              copy-clipboard-field.my-3(
                :value="getZoomSdkLink(lesson.meeting.id)"
                label="Трансляция в СДО"
              )
              copy-clipboard-field(
                :value="lesson.meeting.join_url"
                label="Ссылка Zoom"
              )
      v-list-item-action.mr-4
        //- task-menu(
        //-   :tasks="lesson.tasks"
        //-   unit-model="lessons"
        //-   :unit-id="lesson.id"
        //-   @task:detach="$set(lesson, 'tasks', $event)"
        //-   @task:attach="lesson.tasks.push($event)"
        //- )
        v-menu(top)
          template(#activator="{ on }")
            v-btn(
              v-if="editable"
              v-on="on"
              icon
            )
              v-icon mdi-menu
          v-list
            v-list-item(
              :to=`{
                name: 'LessonUpdate',
                params: { id: $route.params.id, unitId: unitId, lessonId: lesson.id },
              }`
              fab
              depressed
            )
              v-list-item-action
                v-icon(color="secondary") mdi-pencil
              v-list-item-title Редактировать
            v-list-item(
              v-if="editable"
              @click.stop="openDeleteLessonDialog(lesson)"
              title="Удалить урок"
              fab
              depressed
            )
              v-list-item-action
                v-icon(color="red darken-2") mdi-delete-outline
              v-list-item-title Удалить

  // Сообщение об отсутствии уроков
  .no-exists
    v-list-item(
      v-if="lessons && !lessons.length"
      class="lesson-item"
    )
      v-list-item-content
        v-list-item-title(class="grey--text") У данной темы еще нет уроков
  v-btn.mb-0(
    v-if="editable"
    outlined block
    color="success"
    :to=`{
      name: 'LessonCreate',
      params: { id: $route.params.id, unitId: unitId },
    }`
  )
    v-icon(color="success") mdi-plus
    .success--text Добавить урок
</template>
<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  props: {
    editable: { type: Boolean, default: false },
    lessons: { type: Array, required: true },
    unitId: { type: [String, Number], required: true },
  },
  data() {
    return {
      draggable: {
        name: 'CourseUnitListSub',
      },
    };
  },
  methods: {
    openDeleteLessonDialog(lesson) {
      this.$modals.show('confirm-controller', {
        title: 'Вы действительно хотите хотите удалить данный урок?',
        message: lesson.meeting ? 'К данному урок прикреплена конференция, которая тоже будет удалена' : '',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.lessons.deleteLesson(lesson.id);
          this.$emit('deleted', lesson);
          this.$emit('deleteLesson', lesson);
          this.$modals.close();
        },
      });
    },
    // deleteLesson() {
    //   const unitIdx = this.units.findIndex(
    //     (i) => i.id === this.deleteInstance.course_unit_id,
    //   );
    //   const lessons = this.units[unitIdx].lessons.filter(
    //     (l) => l !== this.deleteInstance,
    //   );
    //   this.$set(this.units[unitIdx], 'lessons', lessons);
    //   this.deleteLessonDialog = false;
    //   this.deleteInstance = {};
    // },
    getZoomSdkLink(meetingId) {
      const { href } = this.$router.resolve({
        name: 'Meeting',
        params: { id: meetingId },
      });
      return `${window.location.origin}${href}`;
    },
  },
};
</script>
